/**
 * Format a Date as YYYY-MM-DD in the local timezone.
 * Avoids UTC drift from Date#toISOString() (e.g. UK evening/night appearing as the previous day).
 */
export function formatDateLocalYMD (d) {
  const y = d.getFullYear()
  const m = String(d.getMonth() + 1).padStart(2, '0')
  const day = String(d.getDate()).padStart(2, '0')
  return `${y}-${m}-${day}`
}

export function getTodayLocalYMD () {
  const d = new Date()
  d.setHours(0, 0, 0, 0)
  return formatDateLocalYMD(d)
}

/**
 * Default invoice range: Monday through Wednesday of the ISO-style week (Mon–Sun),
 * with the end date capped at today (local calendar). Supports invoicing earlier in the week
 * for a Wednesday payment date when the API allows.
 */
export function getDefaultInvoiceDateRange () {
  const today = new Date()
  today.setHours(0, 0, 0, 0)
  const todayStr = formatDateLocalYMD(today)
  const dayOfWeek = today.getDay()
  const diffToMonday = dayOfWeek === 0 ? -6 : 1 - dayOfWeek
  const monday = new Date(today)
  monday.setDate(today.getDate() + diffToMonday)
  monday.setHours(0, 0, 0, 0)
  const wednesday = new Date(monday)
  wednesday.setDate(monday.getDate() + 2)
  wednesday.setHours(0, 0, 0, 0)
  const wednesdayStr = formatDateLocalYMD(wednesday)
  const date_from = formatDateLocalYMD(monday)
  const date_to = wednesdayStr > todayStr ? todayStr : wednesdayStr
  return { date_from, date_to }
}
